import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { ServiceaftaleStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';
import { EditServiceabonnementTilvalgDialogComponent } from 'src/app/components/tilvalg/edit-serviceabonnement-tilvalg-dialog/edit-serviceabonnement-tilvalg-dialog.component';
import { EnvironmentLoaderService } from 'src/app/services/environment-loader.service';
import { ServiceAgreementStateService } from 'src/app/services/serviceAgreementState.service';
import { EditTilvalgDialogData } from '../../../models';

@Component({
  selector: 'app-tilvalg',
  templateUrl: './tilvalg.component.html',
  styleUrls: ['./tilvalg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilvalgComponent implements OnInit {
  @Input() tilvalg: TilvalgDto[];
  @Input() serviceaftale: ServiceaftaleDto;
  @Input() hasRights: boolean;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private serviceAftaleStateService: ServiceAgreementStateService,
  ) {}

  ngOnInit(): void {}

  editTilvalg() {
    if (new Date(this.serviceaftale.startDate) > new Date()) {
      this.router.navigate(['/tilvalg/edit', this.serviceaftale.serviceAftaleNo], {
        queryParams: {
          validFrom:
            new Date(this.serviceaftale.startDate) > new Date()
              ? new Date(this.serviceaftale.startDate).toOkDateString()
              : new Date().toOkDateString(),
        },
        state: {
          data: {
            serviceaftale: this.serviceaftale,
          },
        },
      });
      return;
    }

    let data: EditTilvalgDialogData = {
      serviceaftale: this.serviceaftale,
      overskrift: 'Hvordan vil du skifte tilvalg?',
      buttonTekst: 'Skift tilvalg',
      allowInstantChange: true,
    };

    let dialogRef = this.dialog.open(EditServiceabonnementTilvalgDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((validFrom) => {
      if (validFrom) {
        this.router.navigate(['/tilvalg/edit', this.serviceaftale.serviceAftaleNo], {
          queryParams: { validFrom: validFrom },
          state: {
            data: {
              serviceaftale: this.serviceaftale,
            },
          },
        });
      }
    });
  }

  isServiceaftalePendingTermination() {
    return this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.ActivePendingTermination;
  }

  isServiceaftaleTerminatedOrHasPendingTermination() {
    return (
      this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Terminated ||
      this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.ActivePendingTermination
    );
  }

  canServiceaftaleBeReactivated(): boolean {
    return this.serviceAftaleStateService.canServiceaftaleBeReactivated(this.serviceaftale);
  }
}
